import type { Database } from '@fundline/db/supabase';
import { createClient } from '@supabase/supabase-js';
import { captureAuthRedirectError } from './auth-redirect.ts';
import { env } from './env.ts';

function makeClient() {
  // Must run before createClient, which reads the URL fragment.
  captureAuthRedirectError();
  const { VITE_SUPABASE_URL, VITE_SUPABASE_PUBLISHABLE_KEY } = env();
  return createClient<Database>(VITE_SUPABASE_URL, VITE_SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      // Implicit flow: invite and sign-in links work on any device, not only the browser that asked
      // for them (PKCE would need the same browser). Tokens arrive in the URL fragment, never in logs.
      flowType: 'implicit',
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    },
  });
}

let client: ReturnType<typeof makeClient> | undefined;

/** The browser's Supabase client (publishable key + the user's session; RLS applies to everything). */
export function supabase() {
  client ??= makeClient();
  return client;
}

export type SupabaseClient = ReturnType<typeof supabase>;
